import { API_URL } from "../config/connect";

class ExemptPhoneNumbersAPI {
  async makeRequest(endpoint, options = {}) {
    const token = localStorage.getItem('google_id_token');
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      ...options,
    };

    const response = await fetch(`${API_URL}${endpoint}`, config);
    
    if (!response.ok) {
      let message = `HTTP error! status: ${response.status}`;
      try {
        const body = await response.json();
        if (typeof body?.detail === 'string') message = body.detail;
        else if (Array.isArray(body?.detail) && body.detail[0]?.msg) message = body.detail[0].msg;
        else if (body?.message) message = body.message;
      } catch {
        // keep default message
      }
      const error = new Error(message);
      error.status = response.status;
      throw error;
    }
    
    return response.json();
  }

  async getAll() {
    return this.makeRequest('/api/v1/admin/exempt-phone-numbers');
  }

  async add(data) {
    return this.makeRequest('/api/v1/admin/exempt-phone-numbers', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async update(id, data) {
    return this.makeRequest(`/api/v1/admin/exempt-phone-numbers/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async delete(id) {
    return this.makeRequest(`/api/v1/admin/exempt-phone-numbers/${id}`, {
      method: 'DELETE',
    });
  }
}

export const exemptPhoneNumbersAPI = new ExemptPhoneNumbersAPI();
